// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__nlby2","artCardAuthor":"styles_artCardAuthor__2nag8","name":"styles_name__Q-zyL"};